export default __webpack_public_path__ + "static/media/talleres.7add38f7.jpg";